import { render, staticRenderFns } from "./caiList.vue?vue&type=template&id=1072a11c&scoped=true&"
import script from "./caiList.vue?vue&type=script&lang=js&"
export * from "./caiList.vue?vue&type=script&lang=js&"
import style0 from "./caiList.vue?vue&type=style&index=0&id=1072a11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1072a11c",
  null
  
)

export default component.exports